import Dexie, { type EntityTable } from "dexie";
import { normalizeProject, type AssetFileRecord, type AssetRecord, type PhotoFolioProject } from "../domain/project";

class PhotoFolioDatabase extends Dexie {
  projects!: EntityTable<PhotoFolioProject, "id">;
  assets!: EntityTable<AssetRecord, "id">;
  assetFiles!: EntityTable<AssetFileRecord, "id">;

  constructor() {
    super("photofolio");
    this.version(1).stores({
      projects: "id, updatedAt, lastOpenedAt",
      assets: "id, projectId, createdAt",
      assetFiles: "id, [projectId+assetId+variant], projectId, assetId",
    });
  }
}

export const db = new PhotoFolioDatabase();

export async function listProjects() {
  const records = await db.projects.toArray();
  const projects: PhotoFolioProject[] = [];
  for (const record of records) {
    try {
      projects.push(normalizeProject(record, { preserveTimestamps: true }));
    } catch {
      // Keep a damaged or unsupported record from preventing healthy projects from opening.
    }
  }
  return projects.sort((a, b) => new Date(b.lastOpenedAt).getTime() - new Date(a.lastOpenedAt).getTime());
}

export async function saveProject(project: PhotoFolioProject) {
  await db.projects.put(project);
}

export async function removeProject(projectId: string) {
  const fileRows = await db.assetFiles.where("projectId").equals(projectId).toArray();
  await db.transaction("rw", db.projects, db.assets, db.assetFiles, async () => {
    await db.projects.delete(projectId);
    await db.assets.where("projectId").equals(projectId).delete();
    await db.assetFiles.bulkDelete(fileRows.map((row) => row.id));
  });
}
